module.exports = __webpack_public_path__ + "media/images/default/pages/business_cooperation/main/4-f65a5aff9094e81a9c34fb1bba25359c.svg";